import { GuidT } from '@/types/common';
import { ClothingFormIF } from '@/components/forms/EditClothingForm/EditClothingForm.types';

export const getFormattedResult = ({
    imageId,
}: {
    imageId?: GuidT | null;
}): ClothingFormIF => ({
    guid: '',
    imageId: imageId || '',
    categoryGuid: '',
    colorGuid: '',
    suitableSeason: [],
    materialId: null,
    brandGuid: null,
    fit: null,
    pattern: null,
});
